import { Injectable, Optional } from '@angular/core';
import { Observable, empty, of, from, EMPTY } from 'rxjs';
import { tap, map, switchMap, catchError } from 'rxjs/operators';
import { BeActionService } from './be-action.service';
import { FormMessageService } from './form-message.service';
import { FormNotifyService } from './form-notify.service';
import { LanguageService } from './languag.service';
import { FormLoadingService } from './form-loading/form-loading.service';
import { FormErrorService } from './error/form-error.service';
import { WFSubmiteService, InteractionResponse, ExcutionResponse } from '@gsp-wf/rtdevkit';
import { WfTaskHandlerService } from '@gsp-wf/wf-task-handler';
import { BefRepository } from '@farris/bef';
import { Entity, FrameContext } from '@farris/devkit';
import { WFFlowchartService } from '@gsp-wf/ui-flowchart';
import { FormNotifyStrategyService } from './form-notify-strategy.service';
import { BodyWithRequestInfo } from './../lib/types';
// tslint:disable: max-line-length
/**
 * å®¡æ¹æå¡
 * @Scope FrameComponent
 */
@Injectable()
class ApproveService {

  /**
   * å®ä½ä»åº
   */
  private repository: BefRepository<Entity>;

  /**
   * æé å½æ°
   */
  constructor(
    private formLoadingService: FormLoadingService,
    private beActionService: BeActionService,
    private msgService: FormMessageService,
    private notifyService: FormNotifyService,
    @Optional() private languageService: LanguageService,
    private formErrorService: FormErrorService,
    private frameContext: FrameContext,
    @Optional() private submitter: WFSubmiteService,
    @Optional() private flowchartService: WFFlowchartService,
    @Optional() private wfTaskHandlerService: WfTaskHandlerService
  ) {
    if (this.frameContext) {
      this.repository = this.frameContext.repository as BefRepository<Entity>;
      if (!this.wfTaskHandlerService) {
        this.wfTaskHandlerService = this.frameContext.injector.get(WfTaskHandlerService, null);
      }
    }
  }

  /**
   * å¸¦æäº¤äºçæäº¤å®¡æ¹
   */
  submitApproveWithInteraction(bizBillID: string) {
    return this.submitApprove(bizBillID);
  }

  /**
   * æäº¤å®¡æ¹
   * @param bizBillID ä¸å¡åæ®id
   * @param interactionResult åç«¯äº¤äºç»æ
   * @deprecated å·²åºå¼ï¼æ¸ä½¿ç¨åå«å¥å£åæ®çå®¡æ¹
   */
  submitApprove(bizBillID: string, interactionResult?: InteractionResponse): Observable<any> {
    if (!bizBillID) {
      // this.msgService.error(this.languageService.unallowEmptyBizBillId);
      this.notifyService.info(this.languageService.unallowEmptyBizBillId, { hideTitle: true });
      return empty();
    }

    const actionUri = 'submittoapprovevoaction';

    const restService = this.beActionService.getRestService();

    const body: BodyWithRequestInfo = {
      requestInfo: restService.buildRequestInfo(),
      bizInstID: bizBillID,
      interactionResult: interactionResult ? {
        procDefId: interactionResult.processDefinitionId
      } : {}
    };

    this.formLoadingService.show();

    // æ·»å æç¤º
    const action$ = this.beActionService.invokeAction(actionUri, 'PUT', null, null, body);
    // ç®ååå«ä¸ç§æåµï¼
    // 1. ç¬¬ä¸æ¬¡æäº¤æåï¼æå¡ç«¯è¿åæµç¨å®ä¾id
    // 2. ç¬¬ä¸æ¬¡æäº¤æåï¼æå¡ç«¯è¿åæµç¨å®ä¾idï¼å¹¶è¿åå¤ä¸ªåä¸èï¼äº¤äºæ¶æäº¤åä¸è
    // 3. ç¬¬ä¸æ¬¡æäº¤æªæåï¼æå¡ç«¯è¿åå¤ä¸ªæµç¨å®ä¹ï¼éè¦äº¤äºåç¬¬äºæ¬¡æäº¤å®¡æ¹ï¼ç¬¬äºæ¬¡æäº¤ä¼åºç°æåµ1åæåµ2

    return action$.pipe(
      map((result): ExcutionResponse => {
        if (result && result.returnValue && result.returnValue.excutionResponse) {
          var wfResponse: ExcutionResponse = result.returnValue.excutionResponse;
          return wfResponse;
        }
      }),
      switchMap((response: ExcutionResponse) => {
        if (response && response.procInstId) {
          if (this.repository) {
            const updating$ = this.repository.updateById(bizBillID);
            return updating$.pipe(tap(() => {
              this.formLoadingService.hide();
              // this.notifyService.info(this.languageService.submitSuccess);
              FormNotifyStrategyService.success(this.notifyService, this.languageService.submitSuccess);
            }), map(() => {
              return response;
            }));
          } else {
            this.formLoadingService.hide();
            // this.notifyService.info(this.languageService.submitSuccess);
            FormNotifyStrategyService.success(this.notifyService, this.languageService.submitSuccess);
            return of(response);
          }
        } else {
          return of(response);
        }
      }),
      switchMap((response: ExcutionResponse) => {
        if (response.needInteraction) {
          return from(new Promise((resolve) => {
            this.submitter.excute(response, (interactionResponse: InteractionResponse) => {
              // å¦ææ­¤æ¬¡æªæäº¤ï¼èéæ©åå¾å°äºæµç¨å®ä¹IDï¼åå¨æ­¤æäº¤å®¡æ¹
              if (!response.procInstId && interactionResponse.processDefinitionId) {
                this.submitApprove(bizBillID, interactionResponse).subscribe(() => {
                  resolve();
                });
              } else {
                resolve();
              }
            });
          }));
        } else {
          return of(null);
        }
      }),
      catchError(
        error => {
          this.formLoadingService.hide();
          // this.formErrorService.exception(this.languageService.submitFaild, error);
          return of(error);
        }
      )
    );
  }
  /**
   * æäº¤å®¡æ¹(å¸¦å¥å£åæ®)
   * @param bizBillID ä¸å¡åæ®Id
   * @param bizDefKey å¥å£åæ®Id
   * @param options options
   * @param interactionResult äº¤äºç»æ
   */

  public submitApproveWithBizDefKey(bizBillID: string, bizDefKey: string, options?: any, interactionResult?: InteractionResponse): Observable<any> {
    if (!bizBillID) {
      this.notifyService.warning(this.languageService.unallowEmptyBizBillId, { hideTitle: true });
      return EMPTY;
    }
    if (!bizDefKey) {
      this.notifyService.warning(this.languageService.bizDefKeyRequired, { hideTitle: true });
      return EMPTY;
    }
    try {
      if (options && typeof (options) === 'string') {
        options = JSON.parse(options);
      }
    } catch (e) {
      throw new Error('ArgumentError:options not a valid json string.');
    }

    const actionUri = 'submittoapprovewithpayload';

    const restService = this.beActionService.getRestService();

    const body: BodyWithRequestInfo = {
      requestInfo: restService.buildRequestInfo(),
      approvePayload: {
        startProcessPayload: {
          bizDefKey: bizDefKey,
          dataId: bizBillID,
          name: options && options.name || '',
          variables: options && options.variables || {}
        }
      }
    };
    if (interactionResult) {
      body.approvePayload.startProcessPayload.processDefinitionId = interactionResult.processDefinitionId;
      body.approvePayload.startProcessPayload.processDefinitionKey = interactionResult['processDefinitionKey'];
    }
    this.formLoadingService.show();

    // æ·»å æç¤º
    const action$ = this.beActionService.invokeAction(actionUri, 'PUT', null, null, body);
    // ç®ååå«ä¸ç§æåµï¼
    // 1. ç¬¬ä¸æ¬¡æäº¤æåï¼æå¡ç«¯è¿åæµç¨å®ä¾id
    // 2. ç¬¬ä¸æ¬¡æäº¤æåï¼æå¡ç«¯è¿åæµç¨å®ä¾idï¼å¹¶è¿åå¤ä¸ªåä¸èï¼äº¤äºæ¶æäº¤åä¸è
    // 3. ç¬¬ä¸æ¬¡æäº¤æªæåï¼æå¡ç«¯è¿åå¤ä¸ªæµç¨å®ä¹ï¼éè¦äº¤äºåç¬¬äºæ¬¡æäº¤å®¡æ¹ï¼ç¬¬äºæ¬¡æäº¤ä¼åºç°æåµ1åæåµ2

    return action$.pipe(
      map((result): ExcutionResponse => {
        if (result && result.returnValue && result.returnValue.excutionResponse) {
          const wfResponse: ExcutionResponse = result.returnValue.excutionResponse;
          return wfResponse;
        }
      }),
      switchMap((response: ExcutionResponse) => {
        if (response && response.procInstId) {
          if (this.repository) {
            const updating$ = this.repository.updateById(bizBillID);
            return updating$.pipe(tap(() => {
              this.formLoadingService.hide();
              // this.notifyService.info(this.languageService.submitSuccess);
              FormNotifyStrategyService.success(this.notifyService, this.languageService.submitSuccess);
            }), map(() => {
              return response;
            }));
          } else {
            this.formLoadingService.hide();
            // this.notifyService.info(this.languageService.submitSuccess);
            FormNotifyStrategyService.success(this.notifyService, this.languageService.submitSuccess);
            return of(response);
          }
        } else {
          return of(response);
        }
      }),
      switchMap((response: ExcutionResponse) => {
        if (response.needInteraction) {
          return from(new Promise((resolve) => {
            this.submitter.excute(response, (interactionResponse: InteractionResponse) => {
              // å¦ææ­¤æ¬¡æªæäº¤ï¼èéæ©åå¾å°äºæµç¨å®ä¹IDï¼åå¨æ­¤æäº¤å®¡æ¹
              if (!response.procInstId && interactionResponse.processDefinitionId) {
                this.submitApproveWithBizDefKey(bizBillID, bizDefKey, options, interactionResponse).subscribe(() => {
                  resolve();
                });
              } else {
                resolve();
              }
            });
          }));
        } else {
          return of(null);
        }
      }),
      catchError(
        error => {
          this.formLoadingService.hide();
          // this.formErrorService.exception(this.languageService.submitFaild, error);
          return of(error);
        }
      )
    );
  }
  /**
   * æäº¤å®¡æ¹(å¸¦å¥å£åæ®ä½¿ç¨wfæ§ä»¶)
   * @param bizBillID ä¸å¡åæ®Id
   * @param bizDefKey å¥å£åæ®Id
   * @param options ä¸ä¸æåæ°
   * @param variables å¯éåæ°
   */
  public submitApproveWithBizDefKeyUseControl(bizBillID: string, bizDefKey: string, options: any = {}, variables?: any) {
    if (!bizBillID) {
      this.notifyService.warning(this.languageService.unallowEmptyBizBillId, { hideTitle: true });
      return EMPTY;
    }
    if (!bizDefKey) {
      this.notifyService.warning(this.languageService.bizDefKeyRequired, { hideTitle: true });
      return EMPTY;
    }
    if (!options || typeof options !== 'object') {
      options = {};
    }
    const payload: any = {
      dataId: bizBillID,
      bizDefKey,
      ...options
    };
    // å¤çvariablesåæ°
    if (variables) {
      if (variables.startsWith('{') && variables.endsWith('}')) {
        try {
          variables = JSON.parse(variables);
        } catch {
          variables = {};
        }
      }
      payload.variables = variables;
    }
    return this.wfTaskHandlerService && this.wfTaskHandlerService.startProcess(payload);
  }
  /**
   * å­è¡¨æäº¤å®¡æ¹
   * @param bizDefKey å¥å£åæ®Id
   * @param bizId ä¸å¡åæ®Idï¼ä¸»è¡¨ï¼
   * @param childBizId ä¸å¡åæ®Idï¼ä»è¡¨ï¼
   * @param options ä¸ä¸æåæ°
   * @param variables å¯éåæ°
   */
  public childSubmitApproveWithBizDefKey(bizDefKey: string, bizId: string, childBizId: string, options: any = {}, variables?: any): Observable<any> {
    // å¥å£åæ®ä¸è½ä¸ºç©º
    if (!bizDefKey) {
      this.notifyService.warning(this.languageService.bizDefKeyRequired, { hideTitle: true });
      return EMPTY;
    }
    // ä¸»ä¸å¡åæ®Idä¸è½ä¸ºç©º
    if (!bizId) {
      this.notifyService.warning(this.languageService.unallowEmptyBizBillId, { hideTitle: true });
      return EMPTY;
    }
    // ä»è¡¨ä¸å¡åæ®Idä¸è½ä¸ºç©º
    if (!childBizId) {
      this.notifyService.warning(this.languageService.unallowEmptyChildBizBillId, { hideTitle: true });
      return EMPTY;
    }
    if (!options || typeof options !== 'object') {
      options = {};
    }
    const payload: any = {
      dataId: `${bizId},${childBizId}`,
      bizDefKey,
      ...options
    };
    // å¤çvariablesåæ°
    if (variables) {
      if (variables.startsWith('{') && variables.endsWith('}')) {
        try {
          variables = JSON.parse(variables);
        } catch {
          variables = {};
        }
      }
      payload.variables = variables;
    }
    return this.wfTaskHandlerService && this.wfTaskHandlerService.startProcess(payload);
  }
  /**
   * åæ¶å®¡æ¹
   * @deprecated å·²åºå¼ï¼è¯·ä½¿ç¨cancelSubmit
   */
  public cancelApprove(bizBillID: string): Observable<any> {
    if (!bizBillID) {
      this.notifyService.warning(this.languageService.unallowEmptyBizBillId, { hideTitle: true });
      return empty();
    }

    const actionUri = 'canceltosubmitvoaction';

    const restService = this.beActionService.getRestService();

    const body = {
      requestInfo: restService.buildRequestInfo(),
      bizInstID: bizBillID,
    };

    this.formLoadingService.show();

    const action$ = this.beActionService.executeAction(actionUri, 'PUT', null, null, body);
    return action$.pipe(
      switchMap(() => {
        if (this.repository) {
          const updating$ = this.repository.updateById(bizBillID);
          return updating$.pipe(tap(() => {
            this.formLoadingService.hide();
            // this.notifyService.info(this.languageService.cancelApproveSuccess);
            FormNotifyStrategyService.success(this.notifyService, this.languageService.cancelApproveSuccess);
          }));
        } else {
          this.formLoadingService.hide();
          // this.notifyService.info(this.languageService.cancelApproveSuccess);
          FormNotifyStrategyService.success(this.notifyService, this.languageService.cancelApproveSuccess);
          return of();
        }
      }
      ),
      catchError(error => {
        this.formLoadingService.hide();
        // this.formErrorService.exception(this.languageService.cancelApproveFailed, error);
        return of(error);
      }));
  }
  /**
   * åæ¶å®¡æ¹(æ¯æä¸»è¡¨ãå­è¡¨)
   * @param procInstId æµç¨å®ä¾Id
   */
  public cancelSubmit(procInstId: string): Observable<any> {
    if (!procInstId) {
      this.notifyService.warning(this.languageService.procInsIdRequired, { hideTitle: true });
      return EMPTY;
    }
    return this.wfTaskHandlerService && this.wfTaskHandlerService.cancelSubmit({ procInstId: procInstId });
  }
  /**
   * æ¥çæµç¨å¾
   * @param procInstId æµç¨å®ä¾ID
   */
  viewProcess(procInstId: string) {
    if (this.flowchartService) {
      if (!procInstId) {
        this.notifyService.warning(this.languageService.noProcessInstanceId, { hideTitle: true });
        return;
      }
      return this.flowchartService.viewFlowChart(procInstId);
    }
  }


  /**
   * è½¬æ¢éç½®å¤§å°å
   * @param jsonObj Object
   * @deprecated
   */
  private switchPrefixLetter(jsonObj: any, toUpper: boolean): any {
    if (typeof (jsonObj) === 'object' && !!jsonObj) {
      if (Array.isArray(jsonObj)) {
        for (var i = 0; i < jsonObj.length; i++) {
          this.switchPrefixLetter(jsonObj[i], toUpper);
        }
      } else {
        for (const key of Object.keys(jsonObj)) {
          var newKey = (toUpper ? key.substring(0, 1).toUpperCase() : key.substring(0, 1).toLowerCase()) + key.substring(1);
          jsonObj[newKey] = jsonObj[key];
          if (typeof jsonObj[key] === 'object') {
            this.switchPrefixLetter(jsonObj[key], toUpper);
          }
          delete (jsonObj[key]);
        }
      }
    }
    return jsonObj;
  }
}
export { ApproveService };
